import PropTypes from 'prop-types';
// material
import { Popover } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const ArrowStyle = styled('span')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    top: -7,
    zIndex: 1,
    width: 12,
    right: 20,
    height: 12,
    content: "''",
    position: 'absolute',
    borderRadius: '0 0 4px 0',
    transform: 'rotate(-135deg)',
    background: 'var(--mvp-surface, #ffffff)',
    borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.2)}`,
    borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.2)}`,
  },
}));

// ----------------------------------------------------------------------

MenuPopover.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default function MenuPopover({ children, sx, ...other }) {
  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 200,
          overflow: 'inherit',
          color: 'var(--mvp-text, #122136)',
          bgcolor: 'var(--mvp-surface, #ffffff)',
          border: '1px solid var(--mvp-border, #e2e8f0)',
          borderRadius: '14px',
          boxShadow: '0 18px 48px rgba(11, 27, 43, 0.18)',
          ...sx,
        },
      }}
      {...other}
    >
      <ArrowStyle className="arrow" />

      {children}
    </Popover>
  );
}
